var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { WorkspacePollSideEffects } from './components';
export const WorkspaceFilespaceLists = ({ workspaceFilespaceLists, }) => {
    return workspaceFilespaceLists.map(({ filespaceList, workspaceId }) => (_jsx(WorkspacePollSideEffects, { filespaceList: filespaceList, workspaceId: workspaceId }, workspaceId)));
};
_react_refresh_temp_1 = WorkspaceFilespaceLists;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceFilespaceLists");
